import { QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { AgentDto } from '@/models/agent/AgentDto';
import { SelectOption } from '@/models/SelectOption';

export class AgentService {
  private readonly client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/agents');
  }

  async getAll(clientId: Guid | undefined = undefined): Promise<AgentDto[]> {
    if (!clientId) {
      return await this.client.get('');
    } else {
      return await this.client.get(`?clientId=${clientId}`);
    }
  }

  async getAllSelectOptions(clientId?: Guid, includeAll: boolean = true): Promise<SelectOption[]> {
    let agents = await this.getAll(clientId);
    let result = agents.map<SelectOption>(a => {
      return { text: a.AgentName, value: a.AgentId };
    });

    if (includeAll) {
      result.unshift({ text: 'ALL', value: '' });
    }

    return result;
  }
  
  async agentInfo(options: any, clientId: Guid | undefined = undefined): Promise<any> {
    return await this.client.getPostData(`/info?clientId=${clientId}`, options); 
  }
}
